// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx","951":"component---src-templates-workshop-tsx"}[chunkId] + "-" + {"218":"17b61a7c37af955cfb38","532":"a3b2c36e92050ee81272","691":"70f060dba0c281dbabd7","951":"5b6091c049c66ca90b7c"}[chunkId] + ".js";
};